import { useState } from 'react';
import { Modal, Box, Tabs, Tab } from '@mui/material';
import { Close, Visibility, VisibilityOff } from '@mui/icons-material';

const style = {
    position: 'absolute',
    bgcolor: '#152234',
    boxShadow: 1,
    p: '36px 18px 40px 18px',
    color: '#FFF',
    borderRadius: '20px'
};


export default function ForgotPwd({ open, setOpen }) {
    const handleClose = () => setOpen(false);
    const [tabValue, setTabValue] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [showCnfPassword, setShowCnfPassword] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [registerForm, setRegisterForm] = useState({ phoneNumber: '', password: '' });

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handlePasswordVisibility = (type) => {
        if (type === 'new') {
            setShowPassword(!showPassword);
        } else {
            setShowCnfPassword(!showCnfPassword);
        }
    };

    const onChangeFormDetails = (event) => {
        if (event.target.name === 'phone') {
            event.target.value = event.target.value.replace(/\D/g, '')
            setRegisterForm(prev => ({ ...prev, phoneNumber: event.target.value }));
        } else {
            setRegisterForm(prev => ({ ...prev, password: event.target.value }))
        }
        validateForm();
    }

    return (
        <Modal open={open} onClose={null} sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }} style={{ overflow: 'auto' }}>

            <Box sx={style}
                className="bg-[rgba(151,163,186,.59)] w-11/12 md:w-[400px] box-border p-6 rounded-lg shadow-lg text-white "
                style={{ position: 'relative' }}
            >
                <div className='register-head'>
                    <button className='absolute z-10 top-2 right-2' onClick={handleClose}>
                        <Close color='#FFF' />
                    </button>
                    <div className='text-2xl font-bold text-center'>
                        Forgot password
                    </div>
                </div>
                <div className='h-[500px] md:h-auto overflow-auto'>
                    <div className='mt-5'>
                        <Tabs sx={{ color: 'white' }}
                            value={tabValue}
                            onChange={handleTabChange}
                            centered
                            textColor="primary"
                            indicatorColor="primary"
                        >
                            <Tab label="User ID" />
                            <Tab label="Phone" />
                        </Tabs>
                    </div>
                    <form className="mt-6">
                        {/* Conditional rendering for User ID or Phone */}
                        {tabValue === 1 ? (
                            <>
                                <div className='mobile-input mt-6 w-full flex box-border rounded-lg bg-[#1c2d4480] text-white'>
                                    <div className='country-code px-5 bg-[#1c2d4499] py-4 rounded-l-lg'>+91</div>
                                    <input name='phone' minLength={10} maxLength={10} type="text" placeholder='Phone Number'
                                        className='text-base px-5 w-full bg-transparent outline-none font-medium py-4' onChange={onChangeFormDetails} />
                                </div>
                                {formErrors.phoneNumber && <p className='text-red-500 text-sm'>{formErrors.phoneNumber}</p>}
                            </>
                        ) : (
                            <div className="mb-4 bg-[#1c2d4480] rounded-lg text-white">
                                <input name='phone' minLength={10} maxLength={10} type="text" placeholder='User ID'
                                    className='text-base px-5 w-full bg-transparent outline-none font-medium py-4 text-white' onChange={onChangeFormDetails} />
                            </div>
                        )}
                        <div className='mt-8 font-bold'>
                            <button className='py-3 w-full text-center rounded-lg text-[#31db52] shadow-[0 0 12px rgba(79,255,226,.2)] border border-[#31db52] text-base'>SMS OTP</button>
                        </div>

                        {/* <div className='border-b mt-6'></div> */}
                        <div className='flex justify-between mt-6 pt-6 text-center border-t border-[#ffffff1a]'>
                            <div className='font-bold text-lg px-4 w-2/4 border-e border-[#ffffff1a]'>SMS OTP</div>
                            <div className='font-bold text-lg px-4 w-2/4 text-[#31db52]'>RESEND</div>
                        </div>
                        <div className='mobile-input mt-6 w-full flex box-border rounded-lg bg-[#1c2d4480] text-white'>
                            <input name='phone' minLength={10} maxLength={10} type="text" placeholder='Enter SMS OTP code'
                                className='text-base px-5 w-full bg-transparent outline-none font-medium py-4' onChange={onChangeFormDetails} />
                        </div>
                        <div>
                            <div className='pwd-input mt-6 w-full flex box-border px-5 rounded-lg bg-[#1c2d4480] text-white'>
                                <input name='password' type={showPassword ? 'text' : 'password'} placeholder='New Password'
                                    className='text-base w-full bg-transparent outline-none font-medium py-4' onChange={onChangeFormDetails} />
                                <button onClick={() => handlePasswordVisibility('new')}>
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </button>
                            </div>
                            <div className='pwd-input mt-6 w-full flex box-border px-5 rounded-lg bg-[#1c2d4480] text-white'>
                                <input name='password' type={showCnfPassword ? 'text' : 'password'} placeholder='Confirm Password'
                                    className='text-base w-full bg-transparent outline-none font-medium py-4' onChange={onChangeFormDetails} />
                                <button onClick={() => handlePasswordVisibility('cnf')}>
                                    {showCnfPassword ? <Visibility /> : <VisibilityOff />}
                                </button>
                            </div>
                        </div>
                        <div className='mt-8 font-bold'>
                            <button className='py-4 w-full text-center bg-cnf-btn rounded-lg text-base'>Reset Password</button>
                        </div>
                    </form>
                </div>
            </Box>
        </Modal>
    );
}
